import {ICommentConfiguration} from "@webng-types/write-model";

export function commentsEnabled(comments: ICommentConfiguration|undefined) {
  if(comments && typeof comments.publish_mode === 'number') {
    return !!(comments.enabled && comments.publish_mode < 100);
  } else {
    return false
  }
}
